export const tradingLevels = [
  'optionLevel1',
  'optionLevel2',
  'optionLevel3',
  'optionLevel4',
  'optionLevel5',
  'optionLevel6'
];
